import React, { FC, useState } from 'react';
import { stopDefaultEvents } from '../../utils/DataAccessUtils';

require('./InlineEdit.less');

const InlineEdit: FC<any> = ({
	placeholder,
	value,
	setValue,
	onEnter,
	className,
}): React.ReactElement => {
	const [editingValue, setEditingValue] = useState(value);

	const onChange = (event) => setEditingValue(event.target.value);

	const onKeyDown = (event) => {
		if (event.key === 'Enter' || event.key === 'Escape') {
			event.target.blur();

			if (event.key === 'Enter') {
				onEnter && onEnter();
				stopDefaultEvents(event);
			}
		}
	};

	const onBlur = (event) => {
		// if (event.target.value.trim() === '') {
		// 	setValue(value);
		// } else {
		setValue(event.target.value);
		// }
	};

	return (
		<input
			className={className}
			type="text"
			placeholder={placeholder}
			aria-label="Field name"
			value={editingValue}
			onChange={onChange}
			onKeyDown={onKeyDown}
			onBlur={onBlur}
			autoFocus
		/>
	);
};

export default InlineEdit;
